import CIcon from '../../Icons/C';
import CssIcon from '../../Icons/Css';
import FileIcon from '../../Icons/File';
import GitIcon from '../../Icons/Git';
import HtmlIcon from '../../Icons/Html';
import JsIcon from '../../Icons/Js';
import NextIcon from '../../Icons/Next';
import NodeIcon from '../../Icons/Node';
import ReactIcon from '../../Icons/React';
import ThreeIcon from '../../Icons/Three';
import VueIcon from '../../Icons/Vue';
import GsapIcon from '../../Icons/Gsap';
import MongoDBIcon from '../../Icons/Mongodb';
import ReduxIcon from '../../Icons/Redux';
import TypescriptIcon from '../../Icons/Typescript';
import FramerMotionIcon from '../../Icons/FramerMotion';

export const SLIDER_ITEMS = [
  {
    title: 'JavaScript',
    image: JsIcon
  },
  {
    title: 'React',
    image: ReactIcon
  },
  {
    title: 'React Native',
    image: ReactIcon
  },
  {
    title: 'Next.js',
    image: NextIcon
  },
  {
    title: 'Node.js',
    image: NodeIcon
  },
  {
    title: 'Express.js',
    image: NodeIcon
  },
  {
    title: 'HTML5',
    image: HtmlIcon
  },
  {
    title: 'CSS/SCSS',
    image: CssIcon
  },
  {
    title: 'Styled-components',
    image: FileIcon
  },
  {
    title: 'Framer motion',
    image: FramerMotionIcon
  },
  {
    title: 'Three.js',
    image: ThreeIcon
  },
  {
    title: 'Vue.js',
    image: VueIcon
  },
  {
    title: 'Git',
    image: GitIcon
  },
  {
    title: 'C',
    image: CIcon
  },
  // {
  //   title: 'C++',
  //   image: CIcon
  // },
  {
    title: 'C#',
    image: CIcon
  },
  {
    title: 'Bash',
    image: FileIcon
  },
  {
    title: 'GSAP',
    image: GsapIcon
  },
  {
    title: 'MongoDB',
    image: MongoDBIcon
  },
  {
    title: 'Redux',
    image: ReduxIcon
  },
  {
    title: 'Typescript',
    image: TypescriptIcon
  }
];
